module.exports = __webpack_public_path__ + "static/media/education.4314907b.png";